const SEVERITY_OPTIONS = ["Critical", "High", "Medium", "Low", "Informational"];

export default function FindingForm({
  isOpen,
  finding,
  onChange,
  onClose,
  onSave,
  onRequestGenerate,
  isSaving,
  isGenerating,
  canGenerate,
}) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="drawer-shell">
      <button type="button" className="drawer-backdrop" onClick={onClose} aria-label="Close finding drawer" />
      <aside className="finding-drawer">
        <div className="panel-header">
          <div>
            <p className="eyebrow">Finding Intake</p>
            <h2>{finding.id ? "Edit Finding" : "New Finding"}</h2>
          </div>
          <button type="button" className="ghost-button" onClick={onClose}>
            Close
          </button>
        </div>

        <div className="finding-drawer-fields">
          <label className="field">
            <span>Name</span>
            <input value={finding.name || ""} onChange={(event) => onChange("name", event.target.value)} />
          </label>

          <label className="field">
            <span>Severity</span>
            <select value={finding.severity || "Medium"} onChange={(event) => onChange("severity", event.target.value)}>
              {SEVERITY_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>

          <label className="field">
            <span>Location</span>
            <input value={finding.location || ""} onChange={(event) => onChange("location", event.target.value)} />
          </label>

          <label className="field">
            <span>Description</span>
            <textarea
              rows={8}
              value={finding.description || ""}
              onChange={(event) => onChange("description", event.target.value)}
              placeholder="Add the facts, observed behavior, or any short notes you want the LLM to use."
            />
          </label>
        </div>

        {isGenerating ? (
          <div className="drawer-status drawer-status-generating" aria-live="polite">
            <span className="loading-spinner" aria-hidden="true" />
            <span>Generating finding draft...</span>
          </div>
        ) : null}

        <div className="drawer-actions">
          <button type="button" className="secondary-button" onClick={onSave} disabled={isSaving || isGenerating}>
            {isSaving ? "Saving..." : "Save"}
          </button>
          <button
            type="button"
            className="primary-button"
            onClick={onRequestGenerate}
            disabled={!canGenerate || isGenerating}
          >
            {isGenerating ? "Generating..." : finding.id ? "Save and Generate" : "Create and Generate"}
          </button>
        </div>
      </aside>
    </div>
  );
}
